





import { Component, Prop } from 'vue-property-decorator';
import EntityType from "@/models/Shared/EntityType";
import ComponentLocation from '@/models/Shared/ComponentLocation';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import PageRoutes from '@/router/PageRoutes';

@Component({ name: 'OpenEntityInNewWindowBtn' })
export default class extends SaascadaVue {

    @Prop()
    entityId: string;

    @Prop()
    entityType: EntityType;

    @Prop()
    location: ComponentLocation;

    get small() {
        return this.location === ComponentLocation.ListRow;
    }

    async openInNewWindow() {
        switch (this.entityType) {
            case EntityType.DepositAccount:
                window.open(window.location.origin + PageRoutes.DepositAccount.replace(":id", this.entityId));
                break;
            case EntityType.LendingAccount:
                window.open(window.location.origin + PageRoutes.LendingAccount.replace(":id", this.entityId));
                break;
            case EntityType.Person:
                window.open(window.location.origin + PageRoutes.Person.replace(":id", this.entityId));
                break;
            case EntityType.Organisation:
                window.open(window.location.origin + PageRoutes.Organisation.replace(":id", this.entityId));
                break;
            case EntityType.Customer:
                window.open(window.location.origin + PageRoutes.Customer.replace(":id", this.entityId));
                break;
            case EntityType.Product:
                window.open(window.location.origin + PageRoutes.Product.replace(":id", this.entityId));
                break;
            case EntityType.ProductIssue:
                window.open(window.location.origin + PageRoutes.ProductIssue.replace(":id", this.entityId));
                break;
            case EntityType.ProductMigration:
                window.open(window.location.origin + PageRoutes.ProductMigration.replace(":id", this.entityId));
                break;
            case EntityType.RateSource:
                window.open(window.location.origin + PageRoutes.RateSource.replace(":id", this.entityId));
                break;
            default:
                break;
        }
    }

}
